/**
 * A unified lexer for WFDL Expression Syntax and WFDL Type Syntax.
 *
 * This lexer is used in Nearley grammar files (extension ".ne") by using
 * `@include "./wfdl-shared.ne"`, which contains the lexer reference and various
 * utilities for both JS and grammar code.
 */

// @ts-expect-error - TS7016 - Could not find a declaration file for module 'moo'. '/home/runner/work/flow-to-typescript-codemod/flow-to-typescript-codemod/webflow/node_modules/moo/moo.js' implicitly has an 'any' type.
import moo from 'moo';

const objKeys = (keys: Array<string>) =>
  keys.reduce<Record<string, any>>((acc, k) => {
    acc[k] = k;
    return acc;
  }, {});

const keywords = [
  'import',
  'export',
  'from',
  'as',
  'Text',
  'Boolean',
  'Number',
  'Union',
  'Enum',
  'Element',
  'RowEmpty',
  'List',
  'Record',
  'type',
  'const',
];

export default moo.compile({
  WS: {match: /[ \n\t]+/, lineBreaks: true},
  number: /0|[1-9][0-9]*(?:\.[0-9]*)?/,
  // Accept the JSON string escape grammar: `\"`, `\\`, `\/`, `\b`, `\f`,
  // `\n`, `\r`, `\t`, and `\uXXXX`. The printer in wfdl/codegen uses
  // `JSON.stringify` for Text values, so the lexer must accept everything
  // that round-trips through it (notably newlines and tabs inside string
  // content — e.g. an HtmlEmbed `html` field holding inline HTML/SVG).
  string: /"(?:\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})|[^\n"\\])*"/,
  bool: /(?:true|false)/,
  comment: /\/\/.*?$/,
  semicolon: ';',
  dblcolon: '::',
  colon: ':',
  comma: ',',
  arrow: '=>',
  eq: '=',
  plus: '+',
  minus: '-',
  lparen: '(',
  rparen: ')',
  lbrace_pct: '{%',
  pct_rbrace: '%}',
  lbrace: '{',
  rbrace: '}',
  lbrack: '[',
  rbrack: ']',
  labrack: '<',
  rabrack: '>',
  ellipsis: '...',
  dot: '.',
  at: '@',
  keyword: keywords,
  word: {
    match: /[a-zA-Z_$][a-zA-Z0-9_$]*/,
    type: moo.keywords(objKeys(keywords)),
  },
});
